import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Logger } from '../logger.service';
import {
  PaymentConfirmation,
  Transaction,
  TransactionFilter,
  TransactionIdWalletId,
  TransferRequest,
  TransferResponse,
  Wallet,
  WalletCreate,
  WalletRechargeRequest,
  WalletRechargeResponse,
} from '../models/wallet.model';
import { HttpService } from './http.service';
import { NuveiUpdateOrderResponse } from '../models/nuvei.model';
import { HttpErrorResponse } from '@angular/common/http';

const log = new Logger('wallet-service');

interface ResponseData {
  code: string;
  message: string;
  data: unknown;
}

@Injectable({
  providedIn: 'root',
})
export class WalletApiService {
  constructor(private httpS: HttpService) {}

  async createWallet(wallet: WalletCreate): Promise<Wallet | null> {
    try {
      const response = await this.httpS.post(
        environment.api.wallet.url.replace('{{function}}', 'createWallet'.toLowerCase()),
        wallet
      );
      const walletCreated = response?.data as Wallet;
      log.info(walletCreated);
      return walletCreated;
    } catch (error) {
      log.error(error);
    }
    return null;
  }

  async getTransactionHistory(filter: TransactionFilter) {
    try {
      const response = await this.httpS.post(
        environment.api.wallet.url.replace('{{function}}', 'getTransactionHistory'.toLowerCase()),
        filter
      );
      const transactions = response?.data as Transaction[];
      log.info(transactions);
      return transactions;
    } catch (error) {
      log.error(error);
    }
    return null;
  }

  async transferBetweenWallets(transfer: TransferRequest) {
    try {
      const response = await this.httpS.post(
        environment.api.wallet.url.replace('{{function}}', 'transferBetweenWallets'.toLowerCase()),
        transfer
      );
      const trasnfered = response?.data as TransferResponse;
      log.info(trasnfered);
      return trasnfered;
    } catch (error) {
      log.error(error);
    }
    return null;
  }

  async initiateWalletRechargeUser(recharge: WalletRechargeRequest) {
    try {
      const response = await this.httpS.post(
        environment.api.wallet.url.replace('{{function}}', 'initiateWalletRechargeUser'.toLowerCase()),
        recharge
      );
      const trasnfered = response?.data as WalletRechargeResponse;
      log.info(trasnfered);
      return trasnfered;
    } catch (error) {
      log.error(error);
    }
    return null;
  }

  async savePaymentDataForUserRecharge(payment: PaymentConfirmation) {
    try {
      const response = await this.httpS.postErrorFixed(
        environment.api.wallet.url.replace('{{function}}', 'savePaymentDataForUserRecharge'.toLowerCase()),
        payment
      );

      if (!response) return null;
      if (typeof response === 'string') return response;
      return (response.data as any)['updatedOrder'] as NuveiUpdateOrderResponse | null;
    } catch (error: unknown) {
      log.info('obtuve error');
      log.info((error as HttpErrorResponse).error.code);
    }
    return null;
  }

  async confirmWalletRechargeUser(paymentIdentifier: string) {
    try {
      const response = await this.httpS.get(
        environment.api.wallet.url.replace('{{function}}', 'confirmWalletRechargeUser'.toLowerCase()),
        {
          paymentIdentifier,
        }
      );
      log.info(response?.data);
      return response?.data as TransactionIdWalletId;
    } catch (error) {
      log.error(error);
    }
    return false;
  }

  async cancelWalletRechargeUser(transactionId: string) {
    try {
      const response = await this.httpS.post(
        environment.api.wallet.url.replace('{{function}}', 'cancelWalletRechargeUser'.toLowerCase()),
        {
          transactionId,
        }
      );
      log.info(response?.data);
      return true;
    } catch (error) {
      log.error(error);
    }
    return false;
  }

  async redeemCoupon(code: string) {
    return await this.httpS.postWithException(
      environment.api.wallet.url.replace('{{function}}', 'redeemCoupon'.toLowerCase()),
      { code }
    );
  }
}
